// A build's id is a UUID; screens show the first block so an operator can
// match the build a batch reports against the row on the Build tab by eye.
// The full id lives in the element's title.
export function shortBuildId(id: string): string {
  return id.split('-')[0] ?? id;
}
